import { z } from 'zod'

const paymentNotificationTypeSchema = z.literal('payment')
const paymentTypeSchema = z.enum(['bonus', 'googlePay', 'applePay', 'bankTransfer', 'card', 'voucher', 'happyHour'])
const paymentStatusSchema = z.enum(['finished'])

const paymentNotificationPayloadSchema = z.object({
  id: z.string(),
  operation: z.string(),
  status: paymentStatusSchema,
  amount: z.number(),
  date: z.coerce.date(),
  type: paymentTypeSchema,
})

export const paymentNotificationSchema = z.object({
  type: paymentNotificationTypeSchema,
  payload: paymentNotificationPayloadSchema,
})

export type PaymentNotification = z.infer<typeof paymentNotificationPayloadSchema>
